import * as Yup from 'yup';

export const loteDialogSchema = Yup.object({
  old: Yup.string().required('Campo Obrigatório'),
  specie: Yup.string().required('Campo Obrigatório'),
  code: Yup.string().required('Campo Obrigatório'),
  size: Yup.string().required('Campo Obrigatório'),
  price: Yup.string().required('Campo Obrigatório'),
});
